import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HelpText } from '../../model/help-text';

/** @deprecated Use `astral-popover` for inline help or `app-information-block` for section guidance. */
@Component({
    selector: 'app-help-text',
    templateUrl: './help-text.component.html',
    styleUrls: ['./help-text.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HelpTextComponent implements OnInit {
  constructor() {}

  @Input() checkbox: boolean;
  @Input() combobox: boolean;
  @Input() set dataContext(help: string | HelpText) {
    this.help = help;
    this.update();
  }

  help: string | HelpText;
  href: string;
  linkCaption: string;
  showLink: boolean;
  showText: boolean;
  text: string;
  isInitialized: boolean;

  ngOnInit() {
    this.isInitialized = true;
    this.update();
  }

  update(): void {
    if (!this.isInitialized || !this.help) return;

    let isLink = false;

    if (this.help instanceof HelpText) {
      this.text = this.help.text;
      isLink = !!this.help.link;
    } else if (typeof this.help === 'string') {
      this.text = this.help;
    }

    if (isLink && this.help instanceof HelpText) {
      this.href = this.help.link.href;
      this.linkCaption = this.help.link.caption;
      this.showLink = true;
    } else {
      this.href = undefined;
      this.linkCaption = undefined;
      this.showLink = false;
    }
  }

  onMouseEnter() {
    this.showText = true;
  }

  onMouseLeave() {
    this.showText = false;
  }
}
